/* ============================================================
   COVRPACK — Gabarit collection « Gobelet carton » v1.1
   Fichier : assets/covrpack-collection.js
   Chargé uniquement sur le template collection.gobelet-carton.

   1. Sélecteur guidé : les puces construisent une URL de filtres
      Shopify (Search & Discovery) et renvoient vers la grille.
   2. Cartes produit : changement de lot → mise à jour du prix au
      gobelet / prix du lot ; boutons quantité.
   3. « Charger plus » : récupère la page suivante via ?section_id=
      et ajoute les cartes à la grille (la pagination reste indexable).
      v1.4 (07/10/2026) : pagination recalculée d'après les cartes affichées (48 = page 2) ;
      le complément automatique de la page 1 ne la fait plus passer en page 2.
      v1.3 (05/10/2026) : réserve de cartes : « Afficher plus » ajoute
      toujours 24 produits visibles malgré les doublons masqués ; la
      première page est complétée au chargement.
      v1.2 (05/10/2026) : prix dégressif sur les cartes (grille tiers_json) :
      le prix à l'unité et le prix du lot suivent le nombre de lots choisi.
      v1.1 (04/10/2026) : l'adresse passe à ?page=N après chaque
      chargement (retour depuis une fiche = même endroit) ; au-delà de
      data-max-loaded produits, le bouton devient un lien « page
      suivante » classique pour garder la page légère.

   Tout est délégué au document : le contenu de la grille est remplacé
   en AJAX par theme.js lors d'un filtrage.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Sélecteur guidé ---------- */
  function splitVals(str) {
    return (str || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function buildFinderUrl(finder) {
    var params = new URLSearchParams();
    var pTaille = finder.dataset.paramTaille;
    var pMat = finder.dataset.paramMateriau;
    var pParoi = finder.dataset.paramParoi;
    var pPromo = finder.dataset.paramPromo;
    var promoVal = finder.dataset.promoValue;

    var tailleSets = []; // un set par groupe → intersection entre groupes, union dans un groupe
    var mats = [], parois = [], promo = false;

    finder.querySelectorAll('.cvrc-chips').forEach(function (group) {
      var pressed = group.querySelectorAll('.cvrc-chip[aria-pressed="true"]');
      if (!pressed.length) return;
      var groupTailles = [];
      pressed.forEach(function (chip) {
        groupTailles = groupTailles.concat(splitVals(chip.dataset.taille));
        splitVals(chip.dataset.materiau).forEach(function (v) { mats.push(v); });
        splitVals(chip.dataset.paroi).forEach(function (v) { parois.push(v); });
        if (chip.dataset.promo === 'true') promo = true;
      });
      if (groupTailles.length) tailleSets.push(groupTailles);
    });

    var tailles = null;
    tailleSets.forEach(function (set) {
      if (tailles === null) { tailles = set.slice(); return; }
      tailles = tailles.filter(function (v) { return set.indexOf(v) > -1; });
    });
    // Intersection vide (ex. usage "café" + contenance "36–65 cl") : on garde la contenance choisie explicitement
    if (tailles !== null && !tailles.length && tailleSets.length) tailles = tailleSets[tailleSets.length - 1].slice();

    if (tailles && pTaille) tailles.forEach(function (v) { params.append(pTaille, v); });
    if (mats.length && pMat) uniq(mats).forEach(function (v) { params.append(pMat, v); });
    if (parois.length && pParoi) uniq(parois).forEach(function (v) { params.append(pParoi, v); });
    if (promo && pPromo && promoVal) params.append(pPromo, promoVal);

    var qs = params.toString();
    return finder.dataset.target + (qs ? '?' + qs : '') + '#cvrc-grille';
  }

  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }

  function addField(box, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    box.appendChild(input);
  }

  /* Reconstruit les champs du formulaire à partir des puces actives.
     Le bouton « Afficher » est un submit : le navigateur envoie les filtres
     même si un autre script intercepte le clic. */
  function syncFinderFields(finder) {
    var box = finder.querySelector('[data-cvrc-finder-fields]');
    if (!box) return false;
    box.innerHTML = '';

    var url = buildFinderUrl(finder);
    var query = (url.split('?')[1] || '').split('#')[0];
    if (query) {
      new URLSearchParams(query).forEach(function (value, key) {
        addField(box, key, value);
      });
    }

    // Conserve l'aperçu de thème (éditeur Shopify) lors de la navigation
    var current = new URLSearchParams(window.location.search);
    ['preview_theme_id', 'oseid'].forEach(function (key) {
      if (current.get(key)) addField(box, key, current.get(key));
    });

    return query.length > 0;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cvrc-finder] .cvrc-chip');
    if (chip) {
      var on = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', on ? 'false' : 'true');
      syncFinderFields(chip.closest('[data-cvrc-finder]'));
      return;
    }

    /* ---------- 2b. Quantité ---------- */
    var qtyBtn = e.target.closest('[data-cvrc-qty]');
    if (qtyBtn) {
      var input = qtyBtn.parentNode.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.cvrcQty, 10);
      input.value = Math.max(1, next);
      updateTier(qtyBtn.closest('.cvrc-card'));
      return;
    }

    /* ---------- 3. Charger plus ---------- */
    var more = e.target.closest('[data-cvrc-more]');
    if (more) {
      e.preventDefault();
      loadMore(more);
    }
  });

  /* ---------- 2. Changement de lot ---------- */
  document.addEventListener('submit', function (e) {
    var finder = e.target.closest && e.target.closest('[data-cvrc-finder]');
    if (!finder) return;
    var hasFilters = syncFinderFields(finder);
    if (!hasFilters) {
      e.preventDefault();
      var grid = document.getElementById('cvrc-grille');
      if (grid) grid.scrollIntoView();
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-cvrc-lot-select]');
    if (!select) return;
    var card = select.closest('.cvrc-card');
    var opt = select.options[select.selectedIndex];
    if (!card || !opt) return;

    setText(card, '[data-cvrc-unit]', opt.dataset.unit);
    setText(card, '[data-cvrc-lot]', opt.dataset.lot);
    setText(card, '[data-cvrc-units]', opt.dataset.units);
    setText(card, '[data-cvrc-compare]', opt.dataset.compare || '');
    updateTier(card);
  });

  function setText(scope, sel, txt) {
    var el = scope.querySelector(sel);
    if (el && txt !== undefined) el.textContent = txt;
  }

  /* ---------- 3. Charger plus ---------- */
  // v1.3 : les produits masqués (doublons) ne sont pas rendus, donc une page
  // Shopify peut contenir moins de 24 cartes. On garde une réserve (buffer) des
  // cartes déjà récupérées : chaque clic ajoute exactement « page size » cartes,
  // et la première page est complétée au chargement s'il lui en manque.
  function fetchPage(href, sectionId) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-cvrc-grid]');
        if (!g) throw new Error('grid missing');
        var w = doc.querySelector('[data-cvrc-loadmore]');
        var m = w && w.querySelector('[data-cvrc-more]');
        return {
          href: href,
          cards: Array.prototype.slice.call(g.querySelectorAll('.cvrc-card')),
          next: m ? m.getAttribute('href') : null,
          pagination: w && w.querySelector('.pagination')
        };
      });
  }

  function fillGrid(wrap, btn, target, keepUrl) {
    var grid = document.querySelector('[data-cvrc-grid]');
    var sectionId = wrap.dataset.sectionId;
    wrap._cvrcBuf = wrap._cvrcBuf || [];
    if (wrap._cvrcNext === undefined) wrap._cvrcNext = btn ? btn.getAttribute('href') : null;

    function step() {
      while (wrap._cvrcBuf.length && grid.querySelectorAll('.cvrc-card').length < target) {
        var c = wrap._cvrcBuf.shift();
        // v1.5 : pas de doublon (produits déjà mis en avant en tête de la recherche)
        var h = c.getAttribute('data-product-handle');
        if (h && grid.querySelector('.cvrc-card[data-product-handle="' + h + '"]')) continue;
        grid.appendChild(c);
      }
      if (grid.querySelectorAll('.cvrc-card').length >= target || !wrap._cvrcNext) return Promise.resolve();
      return fetchPage(wrap._cvrcNext, sectionId).then(function (pg) {
        wrap._cvrcBuf = wrap._cvrcBuf.concat(pg.cards);
        wrap._cvrcNext = pg.next;
        wrap._cvrcLast = pg.href;
        // v1.4 : la pagination n'est plus remplacée par celle de la page récupérée :
        // elle est recalculée dans afterFill() d'après le nombre de cartes affichées.
        return step();
      });
    }
    return step().then(function () { afterFill(wrap, btn, grid, keepUrl); });
  }

  // Page d'arrivée (?page=N), lue une fois avant toute mise à jour de l'adresse
  var START_PAGE = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;

  // Pagination recalculée : 1 … n-1 n n+1 … dernière, avec flèches.
  // Le HTML d'origine (rendu par Shopify, lu par les robots) sert de modèle pour les flèches.
  function syncPager(wrap, n, last) {
    var pager = wrap.querySelector('.pagination');
    if (!pager) return;
    // Flèche droite ; la flèche « précédent » est la même, retournée en CSS (.cvrc-pg-prev)
    var svg = '<svg aria-hidden="true" focusable="false" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path></svg>';
    function href(k) {
      var u = new URL(window.location.href);
      if (k > 1) u.searchParams.set('page', k); else u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      return u.pathname + u.search + '#cvrc-grille';
    }
    var pages = [];
    for (var k = 1; k <= last; k++) {
      if (k === 1 || k === last || Math.abs(k - n) <= 1) pages.push(k);
      else if (pages[pages.length - 1] !== '…') pages.push('…');
    }
    var html = '';
    if (n > 1) html += '<span class="prev"><a href="' + href(n - 1) + '" title="Précédent" class="cvrc-pg-prev">' + svg + '</a></span>';
    pages.forEach(function (k) {
      if (k === '…') html += '<span class="page">…</span>';
      else if (k === n) html += '<span class="page current" aria-current="page">' + k + '</span>';
      else html += '<span class="page"><a href="' + href(k) + '">' + k + '</a></span>';
    });
    if (n < last) html += '<span class="next"><a href="' + href(n + 1) + '" title="Suivant">' + svg + '</a></span>';
    pager.innerHTML = html;
  }

  function afterFill(wrap, btn, grid, keepUrl) {
    var shown = grid.querySelectorAll('.cvrc-card:not([data-cvrc-boost])').length;
    var total = parseInt((document.querySelector('[data-cvrc-total]') || {}).textContent, 10) || shown;
    document.querySelectorAll('[data-cvrc-shown]').forEach(function (el) { el.textContent = shown; });
    var bar = wrap.querySelector('.cvrc-loadmore__bar');
    if (bar) {
      bar.setAttribute('aria-valuenow', shown);
      var fill = bar.querySelector('i');
      if (fill) fill.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
    }

    // v1.4 : page en cours = nombre de cartes affichées / taille de page
    // (48 cartes = page 2), pour la pagination comme pour l'adresse.
    var size = parseInt(wrap.dataset.pageSize, 10) || 24;
    var pageNow = Math.max(1, START_PAGE - 1 + Math.ceil(shown / size));
    var pageLast = Math.max(pageNow, Math.ceil(total / size));
    syncPager(wrap, pageNow, pageLast);
    if (!keepUrl) {
      try {
        var u = new URL(window.location.href);
        if (pageNow > 1) u.searchParams.set('page', pageNow); else u.searchParams.delete('page');
        window.history.replaceState(window.history.state, '', u.pathname + u.search);
      } catch (err) { /* navigateur ancien */ }
    }

    if (!btn) return;
    var hasMore = wrap._cvrcBuf.length > 0 || !!wrap._cvrcNext;
    var max = parseInt(wrap.dataset.maxLoaded, 10) || 0;
    if (!hasMore) { btn.remove(); return; }
    btn.removeAttribute('disabled');
    // Si la réserve n'est pas vide, la « page suivante » est la dernière récupérée
    btn.setAttribute('href', wrap._cvrcBuf.length ? wrap._cvrcLast : wrap._cvrcNext);
    if (max && shown >= max) {
      // Page assez longue : la suite s'ouvre comme une page classique
      btn.removeAttribute('data-cvrc-more');
      btn.textContent = wrap.dataset.nextLabel || 'Page suivante';
    } else if (btn._cvrcLabel) {
      btn.textContent = btn._cvrcLabel;
    }
    if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
      window.theme.reinitProductGridItem();
    }
  }

  function loadMore(btn) {
    var wrap = btn.closest('[data-cvrc-loadmore]');
    var grid = document.querySelector('[data-cvrc-grid]');
    if (!wrap || !wrap.dataset.sectionId || !grid || btn.hasAttribute('disabled')) return;
    var size = parseInt(wrap.dataset.pageSize, 10) || 24;
    btn._cvrcLabel = btn._cvrcLabel || btn.textContent;
    btn.setAttribute('disabled', '');
    btn.textContent = (window.covrStrings && window.covrStrings.loading) || 'Chargement…';
    fillGrid(wrap, btn, grid.querySelectorAll('.cvrc-card').length + size).catch(function () {
      // Repli : navigation classique vers la page suivante
      btn.removeAttribute('disabled');
      btn.textContent = btn._cvrcLabel;
      window.location.href = btn.getAttribute('href');
    });
  }

  // Page incomplète à cause des doublons masqués : on la complète tout de suite.
  function initFill() {
    var wrap = document.querySelector('[data-cvrc-loadmore]');
    var grid = document.querySelector('[data-cvrc-grid]');
    var missing = wrap ? parseInt(wrap.dataset.hiddenOnPage, 10) || 0 : 0;
    var btn = wrap && wrap.querySelector('[data-cvrc-more]');
    if (!missing || !btn || !grid || wrap._cvrcFilled) return;
    wrap._cvrcFilled = true;
    btn._cvrcLabel = btn.textContent;
    fillGrid(wrap, btn, grid.querySelectorAll('.cvrc-card').length + missing, true).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFill);
  else initFill();

  /* ---------- 4. Prix dégressif sur la carte ---------- */
  var T_LANG = (document.documentElement.lang || 'fr').slice(0, 2);
  var T_TXT = {
    fr: { applied: 'Remise −{p} % appliquée ({n} lots)', next: '−{p} % dès {n} lots', total: 'soit {t} HT' },
    en: { applied: '−{p}% volume discount applied ({n} packs)', next: '−{p}% from {n} packs', total: 'total {t} excl. VAT' },
    es: { applied: 'Descuento −{p} % aplicado ({n} lotes)', next: '−{p} % desde {n} lotes', total: 'total {t} sin IVA' },
    pt: { applied: 'Desconto −{p} % aplicado ({n} lotes)', next: '−{p} % a partir de {n} lotes', total: 'total {t} s/ IVA' },
    de: { applied: '−{p} % Mengenrabatt ({n} Pakete)', next: '−{p} % ab {n} Paketen', total: 'gesamt {t} zzgl. MwSt.' },
    it: { applied: 'Sconto −{p} % applicato ({n} lotti)', next: '−{p} % da {n} lotti', total: 'totale {t} IVA escl.' },
    nl: { applied: '−{p} % korting toegepast ({n} pakken)', next: '−{p} % vanaf {n} pakken', total: 'totaal {t} excl. btw' }
  }[T_LANG] || null;
  function tFmt(n, d) { return n.toLocaleString(document.documentElement.lang || 'fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }) + ' €'; }
  function tSay(tpl, o) { return tpl.replace('{p}', o.p).replace('{n}', o.n).replace('{t}', o.t); }

  function updateTier(card) {
    if (!card || !card.hasAttribute('data-cvrc-tiered')) return;
    var tiers;
    try { tiers = JSON.parse((card.querySelector('[data-cvrc-tiers]') || {}).textContent || 'null'); } catch (e) { return; }
    if (!tiers) return;
    var sel = card.querySelector('[data-cvrc-lot-select]');
    var opt = sel ? sel.options[sel.selectedIndex] : null;
    var sku = opt ? opt.dataset.sku : card.dataset.sku;
    var units = parseInt(opt ? opt.dataset.units : card.dataset.units, 10) || 0;
    var base = parseFloat(opt ? opt.dataset.base : card.dataset.base) || 0;
    var qtyEl = card.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var grid = (tiers[sku] || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var hint = card.querySelector('[data-cvrc-tierhint]');
    if (!grid.length || !base) { if (hint) hint.hidden = true; return; }
    var cur = null, next = null;
    grid.forEach(function (t) { if (t.qty <= qty) cur = t; else if (!next) next = t; });
    var lot = cur ? Math.min(cur.unit_price, base) : base;
    var pct = Math.round((1 - lot / base) * 100);
    var unitEl = card.querySelector('[data-cvrc-unit]');
    var lotEl = card.querySelector('[data-cvrc-lot]');
    var cmpEl = card.querySelector('[data-cvrc-compare]');
    if (unitEl && units > 0) unitEl.textContent = tFmt(lot / units, 3);
    if (lotEl) lotEl.textContent = tFmt(lot, 2);
    if (cmpEl) cmpEl.textContent = pct > 0 ? tFmt(base, 2) : (opt ? (opt.dataset.compare || '') : '');
    card.classList.toggle('is-tier-discount', pct > 0);
    if (hint && T_TXT) {
      var parts = [];
      if (pct > 0) parts.push(tSay(T_TXT.applied, { p: pct, n: qty }) + ' · ' + tSay(T_TXT.total, { t: tFmt(lot * qty, 2) }));
      if (next) {
        var np = Math.round((1 - Math.min(next.unit_price, base) / base) * 100);
        if (np > pct) parts.push(tSay(T_TXT.next, { p: np, n: next.qty }));
      }
      hint.textContent = parts.join(' — ');
      hint.hidden = parts.length === 0;
    }
  }
  function initTiers(root) { (root || document).querySelectorAll('[data-cvrc-tiered]').forEach(updateTier); }
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('.cvrc-card input[name="quantity"]')) updateTier(e.target.closest('.cvrc-card'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTiers(); });
  else initTiers();
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-cvrc-tiered]') || n.querySelector('[data-cvrc-tiered]'))) { initTiers(n.parentNode || document); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
